export default (Alpine) => {

	Alpine.magic('twirePageText', () => (type, path) => {

		return Alpine.store('twirePageText').val(type, path) || '';

	});

	Alpine.directive('twire-page-text-single', (el, { expression }, { effect }) => {

		effect(() => {

			$(el).html(Alpine.store('twirePageText').val('single', expression) || '');

		});

	});

	Alpine.directive('twire-page-text-multi', (el, { expression }, { effect }) => {

		effect(() => {

			const val = Alpine.store('twirePageText').val('multi', expression) || '';
			
            $(el).html(val.replace(/\r?\n/g, '<br />'));

		});

	});

	Alpine.directive('twire-page-text-rich', (el, { expression }, { effect }) => {

		effect(() => {

			$(el).html(Alpine.store('twirePageText').val('rich', expression) || '');

		});

	});

};